/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecommendationRequest
 */
export interface RecommendationRequest {
    /**
     * 
     * @type {string}
     * @memberof RecommendationRequest
     */
    emails: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationRequest
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationRequest
     */
    experienceId?: string;
}

/**
 * Check if a given object implements the RecommendationRequest interface.
 */
export function instanceOfRecommendationRequest(value: object): value is RecommendationRequest {
    if (!('emails' in value) || value['emails'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RecommendationRequestFromJSON(json: any): RecommendationRequest {
    return RecommendationRequestFromJSONTyped(json, false);
}

export function RecommendationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'emails': json['emails'],
        'message': json['message'],
        'experienceId': json['experienceId'] == null ? undefined : json['experienceId'],
    };
}

export function RecommendationRequestToJSON(value?: RecommendationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'emails': value['emails'],
        'message': value['message'],
        'experienceId': value['experienceId'],
    };
}

